import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getProductCategoryUrlId } from "src/react-query/endPoints";
import { useCallback, useMemo } from "react";
export const CategoryAction = ({ categoryId, refetch }) => {
  const { mutate } = useMutate("users");
  const onDelete = useCallback(() => {
    mutate(
      { url: getProductCategoryUrlId(categoryId), method: "DELETE" },
      {
        onSuccess: () => {
          if (refetch) refetch(); // refresh the page
        },
      }
  );
  }, [categoryId, mutate, refetch]);

  const actionList = useMemo(
    () => [
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
      },
    ],
    [onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
